<template>
  <main>
    <div class="container-fluid message">
      <TopTemplate>
        <template #right-element>
          <router-link :to="{name: 'AjoutMessage'}" class="btn button btn-primary" :disabled="loading">
            <i class="icon-Add" />
            {{ $t("button.addMsg") }}
          </router-link>
        </template>
        <template #left-element>
          <h3>{{ $t("title.listMsg") }} ({{ total }})</h3>
        </template>
      </TopTemplate>
      <div class="search-date-wrapper">
        <div class="col-md-10 search">
          <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshMessage()" />
          <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
        </div>

        <div class="col-md-2 search-date-message">
          <div class="select-wrapper">
            <!-- <div class="row"> -->
            <!-- <div class="col-md-12"> -->
            <div class="date-wrapper date-env">
              <span class>{{ $t("barFiltre.date") }}</span>
              <!-- <input
                                              v-model="datede"
                                              id="due_date"
                                              class="form-control input-date filter-date"
                                              type="date"
                                              ref="date1"
                                              @input="searshMessageByDate()"
                    />-->
              <Datepicker v-model="datede" locale="fr" autoApply :enable-time-picker="false" :format="format_date_v1" 
              :max-date="today" @update:modelValue="searshMessageByDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="row card-message">
        <b-card no-body>
          <nav>
            <div class="nav nav-tabs list-nav-pay" id="nav-tab" role="tablist">
              <button
                class="nav-link"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                :class="{active: isReceved}"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                key="1"
                @click="changeTypeMessage(true)"
              >
                {{ $t("message.tabReceived.title") }} ({{ nbrReceivedMessages }})
              </button>

              <button
                class="nav-link"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                :class="{active: !isReceved}"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                key="1"
                @click="changeTypeMessage(false)"
              >
                {{ $t("message.tabSend.title") }} ({{ nbMessagesSent }})
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active">
              <div v-if="!loading && messages.length === 0" class="card text-center d-block pt-2 pb-2">
                <span>{{ $t("common.emptysearshMessage") }}</span>
              </div>
              <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div class="table" v-if="!loading && messages.length > 0">
                <div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table__wrapper">
                        <table class="table table__classes table-message">
                          <thead>
                            <tr class="item_class">
                              <th class="col-md-4">
                                {{ $t("message.title") }}
                              </th>
                              <th class="col-md-4 item-received">
                                {{ itemTwoTable }}
                              </th>
                              <th class="col-md-2 item-date">
                                {{ itemThreeTable }}
                              </th>
                              <th v-if="!isReceved" class="col-md-2 text-center item-nb-read">
                                {{ $t("message.lus") }}
                              </th>
                              <th class="col-md-2 text-center item-action">
                                {{ $t("common.actions") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="noticeReceived in messages"
                              :key="noticeReceived.id"
                              class="item_class"
                              :class="{'new-msg': noticeReceived.nombre_vu === 0, 'receved-msg': isReceved}"                            >
                              <td
                                :class="{
                                  'arabic-text': checkLanguag(noticeReceived.message),
                                }"
                                class="message text-message"
                              >
                                <i v-if="noticeReceived.files.length > 0" class="icon-img"></i>
                                <span v-html="noticeReceived.message" class="content-editor item-content-msg"></span>
                              </td>
                              <td v-if="isReceved">
                                <span v-if="noticeReceived.from">
                                  {{ getDestination(noticeReceived.from.first_name) }}
                                  {{ getDestination(noticeReceived.from.last_name) }}
                                </span>
                                <span v-else>__</span>
                              </td>
                              <td v-else>
                                <span class="item-dist">{{ noticeReceived.destination }} </span>
                              </td>
                              <td>
                                <span>{{ formatDateFR(noticeReceived.created_at) }} à {{ formatTimeNews(noticeReceived.created_at) }}</span>
                              </td>
                              <td v-if="!isReceved" class="text-center">
                                {{ noticeReceived.nombre_vu }}
                              </td>
                              <td class="actions text-center">
                                <i class="icon-eyes" @click="getDetails(noticeReceived) , setItem()">
                                  <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                                </i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="table__wrapper__pagination-wrapper">
                          <div class="pagination">
                            <pagination v-if="last_page > 1" :data-set="pagination" @goToPage="getResults" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <b-modal ref="eventDetail" v-model="modalShow" :size="[referenceMessage.photo ? 'xs' : 'md']" centered class="modal-full-screen" title="Détails message reçu" hide-footer>
        <div v-if="loadingPopup" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-if="!loadingPopup" class="row">
          <div class="col-md-12">
            <div class="bloc-exp">
              <span class="text_recu test"> {{ itemTwoTable }} : </span>
              <span class="info-msg">
                <span v-if="parseInt(referenceMessage.sent_by)=== 1">Admin</span>
    <span  v-if="parseInt(referenceMessage.sent_by) === 2">Parent</span>
    <span  v-if="parseInt(referenceMessage.sent_by) === 3">Enseignant</span>
    <span  v-if="parseInt(referenceMessage.sent_by) === 4">Élève</span>

              </span><br />
              <div v-if="getListStudentFromParent">
                <span class="text_recu">Élève(s) : </span>
                <span class="info-msg">
                  {{ getListStudentFromParent }}
                </span>
                <br />
              </div>
              <span class="text_recu">{{ $t("message.formMsg.date") }} </span>
              <span class="text-secondary news-date">Le {{ formatDateNews(referenceMessage.created_at) }}</span
              ><span class="text-secondary"> à {{ formatTimeNews(referenceMessage.created_at) }}</span>
            </div>
            <p
              :class="{
                'arabic-text': checkLanguag(referenceMessage.message),
              }"
              class="message text-message text-modal"
            >
              <span v-html="referenceMessage.message" class="content-editor item-content-msg"></span>
            </p>
            <hr />
            <span class="text_recu"> {{ $t("tabDetail.files") }}</span>
            <div class="row">
              <span v-if="files.length === 0">
                {{ $t("common.emptyFiles") }}
              </span>
              <span v-else class="col-md-5" v-for="(file, index) in files" :key="index"
                ><i class="icon-file-04"></i>
                <a :href="file.file_url" class="files" download> {{ file.file_name }}</a>
              </span>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import MessageService from "../../services/message.service";
import pagination from "../../components/navigation/Pagination";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";
import {mapGetters} from "vuex";
export default {
  name: "MessagesPage",
  components: {
    TopTemplate,
    pagination,
    Datepicker,
  },
  data() {
    return {
      referenceMessage: {
        nombre_vu: 0,
      },
      nbMessagesSent: 0,
      nbrReceivedMessages: 0,
      isReceved: false,
      tabIndex: 0,
      today: moment().format(),
      pagination: {},
      total: 0,
      modalShow: false,
      datede: null,
      datea: null,
      status: null,
      loading: false,
      loadingPopup: false,
      last_page: null,
      is_current: true,
      type: false,
      referenceMessage: [],
      files: [],
      expediteur: null,
      msgLu: 0,
      msgNonLu: 0,
      params: {
        q: "",
        limit: 20,
        page: 1,
        sort: "created_at",
        order: false,
        notice_status: "received",
      },
      destins: [
        {
          name: "Tous les parents",
          id: "tous_les_parents_de_tous_les_eleves_dans_ecole_x",
        },
        {
          name: "Parent d'un ou plusieurs élèves",
          id: "un_ou_plusieurs_eleves_par_ecole",
        },
        {
          name: "Un ou plusieurs niveaux ",
          id: "parents_de_eleves_par_niveau_dans_ecole_x",
        },
        {
          name: "Une ou plusieurs classes",
          id: "parents_de_eleves_par_classe_dans_ecole_x",
        },
        {
          name: "Un ou plusieurs enseignants",
          id: "un_ou_plusieurs_enseignants_par_ecole",
        },
        {
          name: "Tous les enseignants",
          id: "tous_les_enseignants_par_ecole",
        },
      ],
      messages: [],
      selected: [],
      moment: null,
      listStudent: [],
      pageDetail:null
    };
  },
  computed: {
    itemTwoTable() {
      return this.isReceved ? "Expéditeur" : "Destinataires";
    },
    itemThreeTable() {
      return this.isReceved ? "reçu le" : "envoyé le";
    },
    messageByStudent() {
      return this.referenceMessage.type === "un_ou_plusieurs_eleves_par_ecole";
    },
    getReceivedFrom() {
      if (this.expediteur) {
        const roleMapping = {
          parent: "Parent",
          student: "Élève",
          teacher: "Enseignant",
        };
        const firstRole = this.expediteur.roles[0] || "default";
        const rolesFrom = this.expediteur.roles.length === 1 ? `${roleMapping[firstRole]} / ` : "Parent & Enseignant / ";
        return rolesFrom + this.expediteur.first_name + " " + this.expediteur.last_name;
      } else return null;
    },
    getListStudentFromParent() {
      if (!this.expediteur) return false;
      return this.expediteur.roles[0] === "parent" ? this.referenceMessage.children.map((student) => `${student.last_name} ${student.first_name}`).join(", ") : false;
    },
    ...mapGetters(["isSend", "nbMessageNotLu"]),
  },
  created() {
    this.moment = moment;
  },
  mounted() {
    this.pageDetail = localStorage.getItem('detail'); 
    this.isReceved = !this.isSend;
    this.params.notice_status = this.isReceved ? "received" : "send";

    this.countMessages();
  },
  methods: {
    hiddenModal() {
      if (this.referenceMessage.nombre_vu === 0) {
        this.$store.dispatch("setNbMessage", this.nbMessageNotLu - 1);
        this.referenceMessage.nombre_vu = 1;
      }
    },

    formatDateFR(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    changeTypeMessage(type) {
      this.params.q = null;
      this.params.page = 1;
      let typeMessage = type ? "received" : "send";
      this.params.notice_status = typeMessage;
      this.ListMessages(typeMessage);
    },
    formatDateNews(date) {
      moment.locale("fr");
      return moment(date).format("D MMMM YYYY");
    },
    formatTimeNews(date) {
      moment.locale("fr");
      return moment(date).format("HH:mm");
    },
    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
    getDestination(destination) {
      if (destination) {
        return destination.length > 20 ? destination.substring(0, 20) + "..." : destination;
      } else {
        return "";
      }
    },
    searshMessage: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        if (!this.isReceved) {
          this.ListMessages("send");
        } else {
          this.ListMessages("received");
        }
      }
    }, 200),
    searshMessageByDate: _.debounce(function () {
      if (this.datede != null) {
        this.datede = this.dateTime(this.datede);
      }
      if (!this.isReceved) {
        this.ListMessages("send");
      } else {
        this.ListMessages("received");
      }
    }, 200),
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    clearSavedPage() {
    localStorage.removeItem('detail'); // Suppression de l'élément du localStorage
  },
  setItem() {
  localStorage.setItem('detail', true);  // Ajout de la page courante dans le localStorage

},

    getDetails(data) {
      MessageService.vueMsg(data.id).then((response) => {
        this.hiddenModal();
      });
      if (this.isReceved) {
        const jsonString = JSON.stringify(data);
      localStorage.setItem("monObjetMsg", jsonString);


        this.$router.push({
          name: "detailMsg",
          params: {
            id: data.id,
          },
        });
      } else {
        const jsonString = JSON.stringify(data);
      localStorage.setItem("monObjetMsg2", jsonString);

        this.$router.push({
          name: "DetailsMessage",
          params: {
            id: data.id,
          },
        });
      }
    },
    countMessages() {
      MessageService.nbMessage().then((response) => {
        this.ListMessages(this.params.notice_status);
      });
    },
    ListMessages(noticeStatus) {
      //(noticeStatus === "received") ? this.$store.dispatch("setSended", false) : this.$store.dispatch("setSended", true);
      this.isReceved = noticeStatus === "received";
      this.loading = true;
      this.messages = [];
      MessageService.getAllMe({
        params: {
          created_at: this.datede,
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          notice_status: noticeStatus,
        },
      })
        .then((response) => {
          this.messages = response.data.data;
          const savedPage = localStorage.getItem('currentPageMsg'); 
  if (savedPage && this.pageDetail) {
    this.params.page = Number(savedPage); 
    this.getResults(null,this.params.page);
  }
          this.nbMessagesSent = response.data.nb_messages_sent;
          this.nbrReceivedMessages = response.data.nbr_received_messages;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = this.nbMessagesSent + this.nbrReceivedMessages;
          this.last_page = response.data.meta.last_page;
          if (this.isSend) {
            this.$store.dispatch("setSended", false);
          }
        })
        .catch((error) => {
          console.error(error);
           if (error.response && error.response.status === 403) {
              this.$router.push('/error-403');
            }
        })
        .finally(() => {
          this.loading = false;
          this.clearSavedPage();
          localStorage.removeItem('currentPageMsg');
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },

    getResults(page = null, param,noticeStatus) {
      this.selected = [];
      if (param) {
        this.params.page = param;
      }
      else {
        this.params.page = !page ? this.params.page : page;
      }
      localStorage.setItem('currentPageMsg', this.params.page);  // Ajout de la page courante dans le localStorage
      this.loading = true;

      MessageService.getAllMe({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          notice_status: this.params.notice_status,
        },
      }).then(
        (response) => {
          this.messages = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.nbMessagesSent = response.data.nb_messages_sent;
          this.nbrReceivedMessages = response.data.nbr_received_messages;
          this.total = this.nbMessagesSent + this.nbrReceivedMessages;
          this.last_page = response.data.meta.last_page;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
  },
};
</script>
<style scoped>
.new-msg.receved-msg td span {
  font-weight: 700;
}

.text-message {
  text-align: left;
}
.arabic-text {
  text-align: right;
}
@media (max-width: 991px) {
  th.env {
    width: 20%;
  }
}
</style>
